import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c0eb31d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "grid",
  style: {"max-height":"60vh","overflow":"scroll"}
}
const _hoisted_2 = { class: "flex col text-muted grow align-center g0" }
const _hoisted_3 = { class: "flex text-muted" }
const _hoisted_4 = { class: "text-muted bold" }
const _hoisted_5 = { class: "main-layout" }
const _hoisted_6 = { class: "container flex col" }
const _hoisted_7 = { class: "container flex justify-between g24" }
const _hoisted_8 = { class: "panel grow" }
const _hoisted_9 = {
  class: "title",
  style: {"font-size":"35px"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted f16 bold" }, "Nombre de clients formés", -1))
const _hoisted_11 = { class: "panel grow" }
const _hoisted_12 = {
  class: "title",
  style: {"font-size":"35px"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted f16 bold" }, "Vues aujourd'hui", -1))
const _hoisted_14 = { class: "panel grow" }
const _hoisted_15 = {
  class: "title",
  style: {"font-size":"35px"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted f16 bold" }, "Temps médian", -1))
const _hoisted_17 = { class: "flex grow" }
const _hoisted_18 = { class: "container" }
const _hoisted_19 = { class: "flex col grow" }
const _hoisted_20 = {
  class: "grid",
  id: "resultGrid"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex text-muted grow justify-end" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted bold" }, ".")
], -1))
const _hoisted_22 = {
  key: 0,
  class: "flex align-center justify-center"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WideCard = _resolveComponent("WideCard")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_TrainingChart = _resolveComponent("TrainingChart")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_SeTab = _resolveComponent("SeTab")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      title: "Détails",
      ref: "statModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.visibleResults, (result) => {
            return (_openBlock(), _createBlock(_component_WideCard, {
              icon: "/ico/communication-blue.svg",
              title: _ctx.getEmployeeName(result.employee)
            }, {
              subtitle: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.getStoreName(result.store!!)), 1)
              ]),
              body: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", null, _toDisplayString(result.completed_timestamp != null
                ? _ctx.DateUtils.formatDate(result.completed_timestamp!)
                : "?"), 1)
                ])
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(result.time_spent != null
                ? _ctx.DateUtils.formatTimeWithSecondsFromSeconds(result.time_spent!)
                : "?"), 1)
                ])
              ]),
              _: 2
            }, 1032, ["title"]))
          }), 256))
        ])
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_NavHeader, {
        backButton: "true",
        title: _ctx.state.training!.name
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_SeTab, {
          tabs: [_ctx.Lang.getI18N('overview'), _ctx.Lang.getI18N('table')],
          ref: "storeTab",
          btnSize: 100
        }, {
          "0": _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.state.getTotalViews()), 1),
                _hoisted_10
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.state.getTotalViewsToday()), 1),
                _hoisted_13
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.state.getMedianTimespent()), 1),
                _hoisted_16
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_TrainingChart)
            ])
          ]),
          "1": _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_SearchBar, { targetGridId: "resultGrid" }),
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.visibleStores, (store) => {
                    return (_openBlock(), _createBlock(_component_WideCard, {
                      icon: "/ico/store.svg",
                      title: store.name,
                      onClick: () => _ctx.openStatModal(store)
                    }, {
                      subtitle: _withCtx(() => [
                        _createTextVNode(_toDisplayString(store.address), 1)
                      ]),
                      body: _withCtx(() => [
                        _hoisted_21
                      ]),
                      footer: _withCtx(() => []),
                      _: 2
                    }, 1032, ["title", "onClick"]))
                  }), 256))
                ]),
                (!_ctx.searchResults)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["tabs"])
      ])
    ])
  ], 64))
}